import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { getPublicSurvey } from "../../api/api";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { PUBLIC_FEEDBACK_SURVEY_ID } from "../survey/surveyUtils";

const DEFAULT_THANKS_TITLE = "Thank you";
const DEFAULT_THANKS_BODY = "We'll get back to you soon.";

/**
 * Thank-you screen after public feedback is submitted.
 *
 * @param {Object} props
 * @param {number} [props.userId]
 * @param {object} [props.user]
 * @returns {JSX.Element}
 */
export default function PublicFeedbackThanksPage({ userId, user }) {
  const [thanksTitle, setThanksTitle] = useState(DEFAULT_THANKS_TITLE);
  const [thanksBody, setThanksBody] = useState(DEFAULT_THANKS_BODY);
  const [loading, setLoading] = useState(true);

  const isPersonalUser = Boolean(userId) && user?.type !== "organization";

  useEffect(() => {
    let mounted = true;
    async function load() {
      if (isPersonalUser) {
        setLoading(false);
        return;
      }
      const result = await getPublicSurvey(PUBLIC_FEEDBACK_SURVEY_ID);
      if (!mounted) return;
      const thanks = result.data?.definition?.thanks;
      if (thanks?.title && thanks?.body) {
        setThanksTitle(thanks.title);
        setThanksBody(thanks.body);
      }
      setLoading(false);
    }
    load();
    return () => {
      mounted = false;
    };
  }, [isPersonalUser]);

  if (isPersonalUser) {
    return <Navigate to="/beta" replace />;
  }

  return (
    <div className="bg-ui-background min-h-[calc(100dvh-3.5rem)] w-full">
      <div className="mx-auto max-w-3xl px-4 py-8 sm:py-10">
        <Card className="border-ui-border">
          <CardHeader className="text-center">
            {loading ? (
              <p className="text-sm text-text-muted">Loading…</p>
            ) : (
              <>
                <CardTitle className="font-display text-2xl font-medium text-text-primary sm:text-3xl">
                  {thanksTitle}
                </CardTitle>
                <p className="mt-3 text-base text-text-secondary">{thanksBody}</p>
              </>
            )}
          </CardHeader>
          <CardContent className="flex justify-center">
            <Button asChild size="lg">
              <Link to="/">Back to home</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
